import { Component } from '@theme/component';
class LittleBeesFooter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.media = matchMedia('(min-width:750px)');
    const sync = () => {
      for (const item of this.querySelectorAll('details.lb-footer-v5__group')) {
        if (this.media.matches) item.open = true;
        else if (!item.dataset.mobileReady) { item.open = false; item.dataset.mobileReady = 'true'; }
      }
    };
    this.media.addEventListener('change', sync, { signal });
    sync();
  }
  disconnectedCallback() { super.disconnectedCallback(); this.controller?.abort(); }
}
class LittleBeesSupport extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const check = () => {
      this.frame = 0;
      const chip = this.querySelector('.vjk-wa');
      if (!chip) return;
      const box = chip.getBoundingClientRect();
      const footer = document.querySelector('.vjk-foot__support')?.getBoundingClientRect();
      const footerVisible = footer && footer.top < innerHeight && footer.bottom > 0;
      const overlap = innerWidth < 750 && [...document.querySelectorAll('main button,main select,main input')].some(control => {
        if (!control.getClientRects().length) return false;
        const rect = control.getBoundingClientRect();
        return rect.left < box.right + 6 && rect.right > box.left - 6 && rect.top < box.bottom + 6 && rect.bottom > box.top - 6;
      });
      chip.hidden = !!footerVisible || overlap;
    };
    const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(check); };
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { signal });
    document.addEventListener('shopify:section:load', schedule, { signal });
    schedule();
  }
  disconnectedCallback() { super.disconnectedCallback(); this.controller?.abort(); cancelAnimationFrame(this.frame); }
}
if (!customElements.get('lb-footer')) customElements.define('lb-footer', LittleBeesFooter);
if (!customElements.get('lb-support')) customElements.define('lb-support', LittleBeesSupport);
